import React from "react";
import MetricCard from "../MetricCard";
import { formatNumberWithCommas } from "./metricsUtils";

interface TotalSpentCardProps {
  totalSpent: number;
  timeFrame?: string;
  noData?: boolean;
}

const TotalSpentCard: React.FC<TotalSpentCardProps> = ({
  totalSpent,
  timeFrame = "Past 30 days",
  noData = false,
}) => {
  // Determine tooltip text based on timeFrame
  const tooltipText = timeFrame
    ? `Budget Spent (${timeFrame})`
    : "Monthly budget spent";

  // If totalSpent is 0, consider it as no data
  const hasNoData = noData || totalSpent === 0;

  return (
    <MetricCard
      title="Spent"
      value={`$${formatNumberWithCommas(Math.floor(totalSpent))}`}
      tooltip={tooltipText}
      min={0}
      max={2000}
      current={totalSpent}
      hideMinLabel={true}
      noData={hasNoData}
    />
  );
};

export default TotalSpentCard;
